export const MATRIX_TABS = [
  { value: 'populations', label: '1. Populations' },
  { value: 'definition', label: '2. Definition' },
  { value: 'award-calculation', label: '3. Award calculation' },
];

export const BASELINE_POPULATIONS = [
  { value: 'COMMUTER', label: 'Commuter' },
  { value: 'IN_STATE', label: 'In-State' },
  { value: 'OUT_OF_STATE', label: 'Out-of-State' },
];
